
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useHostnameTheme } from "@/hooks/useHostnameTheme";

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useAuth();
  const { defaultLandingPage, isThemeLoading } = useHostnameTheme();

  useEffect(() => {
    // Wait for auth and theme to load
    if (isLoading || isThemeLoading) {
      return;
    }

    // Only handle redirects for the root path
    if (location.pathname !== '/') {
      return;
    }

    console.log('Index redirect - defaultLandingPage:', defaultLandingPage);

    if (!user) {
      // Use theme's default landing page or fallback to /home
      const targetPath = defaultLandingPage || '/home';
      console.log('Redirecting unauthenticated user to:', targetPath);
      navigate(targetPath);
    } else {
      navigate('/dashboard');
    }
  }, [user, isLoading, isThemeLoading, navigate, location.pathname, defaultLandingPage]);

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-2">Loading...</span>
      </div>
    );
  }

  return null;
};

export default Index;
